import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

import Home from '@/views/Home.vue';
import Room from '@/views/Room.vue';
import Admin from '@/views/Admin.vue';
import Login from '@/views/Login.vue';

Vue.use(Router);

// const ifNotAuthenticated = (to, from, next) => {
// 	if (!store.getters.isAuthenticated) {
// 		next();
// 		return;
// 	}
// 	next('/');
// };

const ifAuthenticated = (to, from, next) => {
	if (store.getters.isAuthenticated) {
		next();
		return;
	}
	next('/login');
};

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'Home',
			component: Home,
			beforeEnter: ifAuthenticated,
		},
		{
			path: '/login',
			name: 'Login',
			component: Login,
		},
		{
			path: '/room/:room_id',
			name: 'Room',
			component: Room,
			beforeEnter: (to, from, next) => {
				store.commit('set_room_id', to.params.room_id);
				next();
			},
		},
		{
			path: '/room/:room_id/admin',
			name: 'Admin',
			component: Admin,
		},
	],
});
